import { render, staticRenderFns } from "./NavigationSettingModal.vue?vue&type=template&id=0aa83b92&scoped=true&"
import script from "./NavigationSettingModal.vue?vue&type=script&lang=js&"
export * from "./NavigationSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa83b92",
  null
  
)

export default component.exports